import { Component, OnInit, ViewChild } from '@angular/core';
import { EditorComponent } from '../../../base/editor/editor.component';
import { HistoryComponent } from '../../../fragments/history/history.component';
import { AppService } from '../../../../services/app.service';
import { HtmlContentService } from '../../../../services/html-content/html-content.service';
import { ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { HtmlContentEnvelope } from '../../../../models/net/envelope/html-content-envelope';

@Component({
    selector: 'app-html-content',
    templateUrl: './html-content.component.html',
    styleUrls: ['./html-content.component.css', '../../../../app.component.css']
})

export class HtmlContentComponent extends EditorComponent {

    @ViewChild("appHistory") appHistory!: HistoryComponent;
    //@ViewChild("fromChipSelector") fromChipSelector!: ChipSelectorComponent;

    public constructor(public override appService: AppService,
                       public override itemService: HtmlContentService,
                       public override route: ActivatedRoute,
                       public override location: Location) {

        super(appService, itemService, route, location, "content", "contents");
    }

    public override initializeEnvelope = (envelope: HtmlContentEnvelope | null): void => {

        super.initializeEnvelope(envelope);

        this.itemEnvelope = new HtmlContentEnvelope(envelope);
        this.itemEnvelopeSnapshot = this.appService.cloneObject(this.itemEnvelope);

        if (this.itemEnvelope?.Document.Item.Body === null || this.itemEnvelope?.Document.Item.Body === undefined) {

            this.itemEnvelope!.Document.Item.Body = "";
        }
    }

    public ngAfterViewInit(): void {

        //this.toChipSelector.itemAdded.subscribe((item: AvatarPrimitive) => {

        //    this.toContactIds.push(item.Id);
        //    this.addMessageContactToMessage(item.Id, 1);
        //});
    }
}
